import { defineMessages } from 'react-intl-next';

export const messages: {
    borderColor: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	borderColor: {
		id: 'company-hub.cards-extension.cards.config-panel.border.color',
		defaultMessage: 'Border color',
		description: 'Label text for the border color customization option',
	},
});
